export const contentKeys = {
  all: ['home-page'] as const,
  contentKpi: (accountId: string) => ['contentKpi', accountId] as const,
  campaignMetrics: (id: string) =>
    [...contentKeys.all, 'campaingMetrics', id] as const,
}

export const welcomeMessageKey = 'daily_welcome_message'
